'use client';

import React, { PropsWithChildren, Suspense } from 'react';
import {
  HydrationBoundary,
  QueryClientProvider,
  type DehydratedState,
} from '@tanstack/react-query';
import { Toaster } from '@mokoboko/components';

import { AuthProvider } from '@/contexts/auth';
import { AnalyticsProvider } from '@/components/analytics-provider';
import { PostHogProvider } from '@/components/posthog-provider';
import { TourController } from '@/components/features/tour/tour-controller';
import { getQueryClient } from '@/lib/query-client';

// The layout already resolved the tenant to decide whether this host is a
// studio at all, so handing that record over saves the browser fetching it
// again — a request the whole shell waits on before it paints anything.
export default function SiteProviders({
  children,
  dehydratedState,
}: PropsWithChildren<{ dehydratedState?: DehydratedState }>) {
  return (
    <>
      <Toaster />
      <QueryClientProvider client={getQueryClient()}>
        <HydrationBoundary state={dehydratedState}>
          <AnalyticsProvider />
          <Suspense fallback={null}>
            <PostHogProvider />
          </Suspense>
          <Suspense fallback={null}>
            <AuthProvider>
              {children}
              <TourController />
            </AuthProvider>
          </Suspense>
        </HydrationBoundary>
      </QueryClientProvider>
    </>
  );
}
